export enum CASHFLOW_TYPES {
  budgetVsCommitGeneral = 'budgetVsCommitGeneral',
  budgetVsCommitsByProject = 'budgetVsCommitsByProject',
  budgetVsPrimeGeneral = 'budgetVsPrimeGeneral',
  budgetVsPrimesByProject = 'budgetVsPrimesByProject',
  primeVsCommitGeneral = 'primeVsCommitGeneral',
  primeVsCommitsByProject = 'primeVsCommitsByProject',
}

export enum CASHFLOW_STATUS {
  IDLE = 'idle',
  LOADING = 'loading',
  RELOADING = 'reloading',
  LOADED = 'loaded',
  ERROR = 'error',
}

export interface CashflowFilters {
  year: number;
  projectIds?: number[];
  propertyIds?: number[];
  projectStatusIds?: number[];
  searchText?: string;
  showZeroDollarLines?: 0 | 1;
}
export interface ICashflowStatRow {
  label: string;
  value: number;
  tooltip: string;
  classes: string;
}
export interface CashflowData {
  firstFutureMonth: number;
  stats: ICashflowStatRow[];
  graph: CashflowGraph;
  items: CashflowDataItem[];
  total: {
    yearTotal: number;
    expenses: number[];
  };
}

export interface CashflowDataItem {
  id: number;
  name: string;
  yearTotal: number;
  expenses: number[];
}

export interface CashflowGraph {
  actualsCol: {
    color: string;
    data: number[];
  };
  budgetCol?: {
    color: string;
    data: number[];
  };
  forecastCol: {
    color: string;
    data: number[];
  };
}
export interface BudgetVsCommitGeneralCashflow {
  cashflow: {
    projects: BudgetVsCommitProjectItem[];
    total: BudgetVsCommitTotal;
  };
  first_future_month: number; // 1-based index
}

export interface BudgetVsCommitProjectCashflow {
  cashflow: {
    items: BudgetVsCommitLineItem[];
    total: BudgetVsCommitTotal;
  };
  first_future_month: number;
}

export interface BudgetVsPrimeGeneralCashflow {
  cashflow: {
    projects: BudgetVsPrimeProjectItem[];
    total: BudgetVsPrimeTotal;
  };
  first_future_month: number;
}

export interface BudgetVsPrimeProjectCashflow {
  cashflow: {
    items: BudgetVsPrimeLineItem[];
    total: BudgetVsPrimeTotal;
  };
  first_future_month: number;
}

export interface PrimeVsCommitGeneralCashflow {
  cashflow: {
    projects: PrimeVsCommitProjectItem[];
    total: PrimeVsCommitTotal;
  };
  first_future_month: number;
}

export interface PrimeVsCommitProjectCashflow {
  cashflow: {
    items: PrimeVsCommitLineItem[];
    total: PrimeVsCommitTotal;
  };
  first_future_month: number;
}

export type MonthlyData = {
  '1': number;
  '2': number;
  '3': number;
  '4': number;
  '5': number;
  '6': number;
  '7': number;
  '8': number;
  '9': number;
  '10': number;
  '11': number;
  '12': number;
};

type BudgetVsCommitTotal = {
  budget: number;
  committed: number;
  remaining: number;
  paid: number;
  to_pay: number;
  monthly_budget: MonthlyData;
  monthly_forecast: MonthlyData;
  monthly_actuals: MonthlyData;
};

type BudgetVsCommitProjectItem = {
  id: number;
  title: string;
  forecast_yearly_total: number;
  monthly_budget: MonthlyData;
  monthly_forecast: MonthlyData;
  monthly_actuals: MonthlyData;
};

type BudgetVsCommitLineItem = {
  id: number;
  name: string;
  division: string;
  cost_type: string;
  yearly_total: number;
  monthly_forecast: MonthlyData;
};

type BudgetVsPrimeTotal = {
  budget: number;
  prime: number;
  funding: number;
  realized: number;
  to_realize: number;
  monthly_budget: MonthlyData;
  monthly_prime: MonthlyData;
  monthly_prime_actuals: MonthlyData;
};

type BudgetVsPrimeProjectItem = {
  id: number;
  title: string;
  prime_yearly_total: number;
  monthly_prime: MonthlyData;
  monthly_budget: MonthlyData;
  monthly_prime_actuals: MonthlyData;
};

type BudgetVsPrimeLineItem = {
  id: number;
  name: string;
  division: string;
  cost_type: string;
  yearly_total: number;
  monthly_prime: MonthlyData;
};

type PrimeVsCommitTotal = {
  anticipated_fee: number;
  prime: number;
  anticipated_income: number;
  committed: number;
  anticipated_costs: number;
  monthly_prime: MonthlyData;
  monthly_forecast: MonthlyData;
};

type PrimeVsCommitProjectItem = {
  id: number;
  title: string;
  forecast_yearly_total: number;
  monthly_prime: MonthlyData;
  monthly_forecast: MonthlyData;
};

type PrimeVsCommitLineItem = {
  id: number;
  name: string;
  division: string;
  cost_type: string;
  yearly_total: number;
  monthly_prime: MonthlyData;
  monthly_forecast: MonthlyData;
};
